import React from 'react'
import reducer from './store'
import { injectReducer } from 'store/index'
import { AdaptableCard } from 'components/shared'
import { useTranslation } from 'react-i18next';
import EmailTemplateTableTools from './components/EmailTemplateTableTools';
import EmailTemplateTable from './components/EmailTemplateTable';

injectReducer('emailTemplatesList', reducer)

const EmailTemplateList = () => {
	const { t } = useTranslation();	
	return (
		<AdaptableCard className="h-full" bodyClass="h-full">
			<div className="lg:flex items-center justify-between mb-4">
				<h3 className="mb-4 lg:mb-0">{t('translation.EmailTemplate')}</h3>				
				<EmailTemplateTableTools/>
			</div>			
			<EmailTemplateTable/>
		</AdaptableCard>
	)
}

export default EmailTemplateList